import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfBrush,
  PdfColor,
  PdfPen,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaGreen implements IColorSchema {
  readonly name = 'Green';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);
  private sizeTopMargin = PdfUnit.FromMillimeters(3);
  private sizeBottomMargin = PdfUnit.FromMillimeters(3);

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    let left = rect.x;
    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;

    const rt = new PdfRect(rect.x, rect.y, rect.width, this.sizeTopHeader);
    page.drawRectangle(null, new PdfBrush(PdfColor.fromRgb(204, 231, 212)), rt);

    if (counter) {
      const s1 = page.measureString(counter, font);
      const r1 = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);

      // Arrow polygon: topLeft, topRight, arrowTip, bottomRight, bottomLeft
      page.drawPolygon(null, new PdfBrush(PdfColor.fromRgb(77, 187, 128)), [
        new PdfPoint(r1.left, r1.top),
        new PdfPoint(r1.right, r1.top),
        new PdfPoint(r1.right + r1.width / 2, r1.centerY),
        new PdfPoint(r1.right, r1.bottom),
        new PdfPoint(r1.left, r1.bottom),
      ]);
      page.drawString(counter, font, PdfBrush.Black, null, r1, ETextAlign.Center);

      left += r1.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    const pen = new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.2);
    pen.dashArray = [10, 5];
    page.drawRectangle(pen, new PdfBrush(PdfColor.fromRgb(220, 220, 220)), rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader + this.sizeTopMargin,
      rect.width,
      rect.height - this.sizeTopHeader - this.sizeBottomMargin - this.sizeBottomMargin
    );
  }
}
